<template>
    <div class="banner-image">
        <div class="banner-type">
            {{ getBannerTypeText(banner) }}
        </div>

        <div
            v-if="banner.icon"
            :class="`banner-icon ${getContextCls(banner)} `"
            style="text-align: center; height: 42px"
        >
            <img style="margin: 3px" :src="getBannerIconUrl(banner)" width="36" height="36" />
        </div>

        <v-img v-if="banner.featured_image_id" :src="getImageUrl(banner)" class="banner-img" width="100px" />
    </div>
</template>

<script>
import { Banner, TYPE as BannerType, CONTEXT as BannerContext } from '@/models/Banner';
import { globalVar, globalParam } from '@/helpers/globals';

/**
 * The image field of the banner list view
 */
export default {
    name: 'BannerListImage',
    props: {
        banner: {
            type: Banner,
            required: true,
        },
    },
    created() {
        this.renderTime = new Date().getTime();
    },

    methods: {
        getImageUrl(rec) {
            let type = 'banner_' + rec.type.toLowerCase(),
                ident = 'banner',
                ending = globalVar('featured_images_config')[type].banner.format,
                ts = this.renderTime;
            if (rec.animated) {
                return `${globalVar('imageroot')}/${rec.relative_image_path}?ts=${ts}`;
            } else {
                return `${globalVar('imageroot')}/${type}/${rec.id}/${ident}.${ending}?ts=${ts}`;
            }
        },
        getBannerTypeText(banner) {
            return BannerType[banner.type] ? this.$t(BannerType[banner.type].title_key) : '';
        },
        getContextCls(banner) {
            return BannerContext[banner.context] ? BannerContext[banner.context].cls : '';
        },
        getBannerIconUrl(banner) {
            let bannerIcons = globalParam('banner_icons') || [];
            let iconEntry = bannerIcons.find((entry) => entry.icon === banner.icon);
            return iconEntry ? iconEntry.defaultIconUrl : '';
        },
    },
};
</script>
